export default "__VITE_ASSET__DbABhIB7__"